module.exports = __webpack_public_path__ + "img/xc-table-2@2x.df4ae081.png";